<nz-table
  *ngIf="!loading && logs.length > 0"
  [nzData]="logs"
  [nzBordered]="false"
  [nzSize]="'middle'"
  [nzShowPagination]="false"
  class="audit-table"
>
  <thead>
    <tr>
      <th nzWidth="180px">Date & time</th>
      <th nzWidth="160px">User</th>
      <th nzWidth="120px">Source</th>
      <th nzWidth="140px">Action type</th>
      <th>Message</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let log of logs">
      <!-- Date -->
      <td>
        {{ log.creationTime | date:'dd MMM yyyy, HH:mm' }}
      </td>

      <!-- User -->
      <td>
        <span nz-typography>{{ log.userName }}</span>
      </td>

      <!-- Source -->
      <td>
        <span
          class="badge badge-prospect"
          *ngIf="log.source === 'Prospective'"
        >
          Prospective
        </span>

        <span
          class="badge badge-maingroup"
          *ngIf="log.source === 'MainGroup'"
        >
          Main Group
        </span>
      </td>

      <!-- Action -->
      <td>
        <nz-tag [nzColor]="getActionColor(log.actionType)">
          {{ log.actionType }}
        </nz-tag>
      </td>

      <!-- Message -->
      <td>
        <span nz-typography>
          {{ log.message }}
        </span>
      </td>
    </tr>
  </tbody>
</nz-table>

<div *ngIf="loading">Loading...</div>

<div *ngIf="!loading && logs.length === 0">
  No audit logs available
</div>
